import { DriverFormInputType } from "Types/driver_form.types";
import { omitBy, isNil, isEmpty } from "lodash";
import CryptoJS from 'crypto-js';

const model = (data:DriverFormInputType) => {
    return omitBy({
        profile:{
            fullName:data.fullName,
            identification:{
                type:data.identityType,
                no:data.passportID,
            },
            primaryPhone: {
                countryCode: data.mobileNo.dialCode,
                number: data.mobileNo.number,
                fullNumber: `${data.mobileNo.dialCode}${data.mobileNo.number}`,
                type: "MOBILE"
            },
            primaryAddress:{
                street1:data.street1,
                street2:data?.street2,
                city:data.city,
                state:data.state,
                postcode:data.postcode,
                country:data.country,
            },
            primaryEmail:data.emailAddress,
            gender:data.gender,
            _id:data.profileID,
        },
        // parentOrgID:data.parentOrgID,
        riderData:omitBy({
            // companyName:data.diolkoCompany,
            vehicleCategory:data.vehicleCategory,
            vehicleType:data?.vehicleType,
            vehicleModel:data?.vehicleModel,
            vehiclePlateNumber:data?.plateNumber,
            payrollDetails:{
                bankType:data.bankType,
                accountNumber:data.accountNo,
                SOCSONo:data?.socsoNo,
                incomeTaxNo:data?.incomeTax,
                EPFNo:data?.epfNo,
                zakatNo:data?.zakatNo,
                HRDFNo:data?.hrdfNo,
            },
            emergencyContactName:data.emergencyContactName,
            emergencyContactNumber:!isNil(data.emergencyContactNo) ? {
                type:'MOBILE',
                countryCode:data.emergencyContactNo.dialCode,
                number:data.emergencyContactNo.number,
                fullNumber:`${data.emergencyContactNo.dialCode}${data.emergencyContactNo.number}`,
            } : null,
            emergencyRelationship:data.relationship,
        },isNil),
    },isEmpty)

}

export default model;